<template>
    <v-app>

        <v-dialog
                v-model="updateCheck"
                max-width="300"
                persistent
        >
            <v-card>
                <v-card-title class="headline">
                    Ehi abbiamo un nuovo aggiornamento!<br>
                </v-card-title>

                <!--<v-card-text>-->
                    <!--Versione: {{VERSION}}-->
                <!--</v-card-text>-->

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            outlined
                            color="teal darken-3"
                            @click="refreshApp"
                    >
                        Aggiorna <strong class="pl-2">IS</strong>App
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-main class="mb-menu">
            <vue-page-transition name="fade">
                <router-view></router-view>
            </vue-page-transition>
        </v-main>

        <!--<v-bottom-navigation dark v-if="isLoggedIn && bottomMenu.length" fixed grow tile :value="menuSelected"-->
                             <!--color="#ad2c2b">-->

            <!--<v-btn to="/member">-->
                <!--<span>Profilo</span>-->
                <!--<v-icon>mdi-account</v-icon>-->
            <!--</v-btn>-->

            <!--<v-btn to="/" class="text-center">-->
                <!--<v-img src="./assets/icon.png" height="30" width="55" class="size65">-->
                    <!--<template v-slot:placeholder>-->
                        <!--<v-progress-circular style="margin: 2px 0 0 -2px !important" size="36" class="ma-0 pa-0"-->
                                             <!--color="white" width="1" indeterminate></v-progress-circular>-->
                    <!--</template>-->
                <!--</v-img>-->
            <!--</v-btn>-->

            <!--&lt;!&ndash;<v-btn :to="bottomMenu[1].to">&ndash;&gt;-->
                <!--&lt;!&ndash;<span>{{bottomMenu[1].title}}</span>&ndash;&gt;-->
                <!--&lt;!&ndash;<v-icon>{{bottomMenu[1].icon}}</v-icon>&ndash;&gt;-->
            <!--&lt;!&ndash;</v-btn>&ndash;&gt;-->

        <!--</v-bottom-navigation>-->

        <v-footer
                dark
                padless
                fixed
        >
            <v-card
                    class="flex"
                    flat
                    tile
            >
                <v-card-text class="py-3 text-right">
                    <small>Vers. {{VERSION}}</small>
                </v-card-text>
            </v-card>
        </v-footer>


        <v-overlay v-if="isLoading">
            <v-progress-circular indeterminate size="50" width="2"></v-progress-circular>
        </v-overlay>

        <flash :msg="$store.state.flashMsg" color="teal lighten-2"></flash>

    </v-app>
</template>

<script>

    import _ from 'lodash'
    import update from './mixins/update'
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex'
    import Pusher from 'pusher-js'

    export default {
        name: 'App',
        mixins: [update],
        data: () => ({
            AppDate: false,
            menuSelected: 1,
            bottomMenu: [],
        }),

        mounted() {


            let _this = this;
            Pusher.logToConsole = false;
            let p = new Pusher('1dc10f5e9857f326bdbe', {
                cluster: 'eu'
            });
            let c = p.subscribe('UserChannel_' + parseInt(localStorage.getItem('_mID')));
            c.unbind('App\\Events\\UserNotification', _this.bindNotification);
            c.bind('App\\Events\\UserNotification', _this.bindNotification);

            this.getNotify();


            this.bottomMenu = this.getBottomMenu;
            //this.notify('Test message');

            let token = localStorage.getItem(this.LST);
            if (token) {
                this.setToken(token);
            }

            if (this.updateCheck) {
                //TODO: vedere perche non va....
                this._pushNotify('ISApp: Nuovo aggiornamento disponibile!');
            }
        },
        computed: {
            ...mapGetters([
                'isLoggedIn',
                'isLoading',
                'getBottomMenu',
                'getMemberID'
            ]),
            ...mapState([
                'LST',
                'VERSION',
            ]),
            imgMenu: function () {
                return this.menuSelected === 2 ? './assets/icon_red.png' : ('./assets/icon_black.png');
            }
        },
        methods: {
            ...mapActions([
                '_Logout',
                '_pushNotify'
            ]),
            ...mapMutations([
                'setToken',
                'setFlash',
                'setUnreadNotify'
            ]),
            bindNotification(data) {
                console.log(data.data);
                this.setFlash(data.data.message);
                //this._pushNotify(data.data.message);
                this.setUnreadNotify(true);
            },

            getNotify() {
                if (!this.isLoggedIn) {
                    return;
                }
                axios
                    .post(this.$store.state.ROOT_API + '/notifications/get', {
                            memberId: this.getMemberID,
                            clubId: this.getMainClubID
                        },
                        {
                            headers: {
                                'Authorization': 'Bearer ' + this.$store.getters.getToken
                            }
                        })
                    .then(resp => {
                        this.setUnreadNotify(_.some(resp.data, ['read_timestamp', null]));
                    })
                    .catch((error) => {
                        console.error(error)
                    });
            },
        }
    }
</script>

<style>

    .v-btn {
        font-weight: 400 !important;
    }

    .v-btn::before, .v-btn--active::before {
        opacity: 0 !important;
    }

    .text-shadow {
        text-shadow: 0 0 4px rgba(0, 0, 0, .6);
    }

    .v-application {
        /* background: #111 url('https://italiasoftair.it/images/assets/italiasoftair_bg.jpg') fixed center top no-repeat !important;
        background-size: contain !important; */
        /* color: #fff !important; */
        background: rgb(0,0,0) !important;
        background: -moz-linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(60,60,60,1) 100%) !important;
        background: -webkit-linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(60,60,60,1) 100%) !important;
        background: linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(60,60,60,1) 100%) !important;
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#551f15",GradientType=1) !important;
    }

    .overlay-left, .overlay-right, .overlay-top, .overlay-bottom {
        background: #333 !important;
    }

    .v-bottom-navigation {
        margin-bottom: constant(safe-area-inset-bottom) !important; /* move footer up on iPhone X - iOS 11.0 */
        margin-bottom: env(safe-area-inset-bottom) !important; /* move footer up on iPhone X - iOS 11.2 */
    }

    .v-bottom-navigation a {
        margin-bottom: constant(safe-area-inset-bottom) !important; /* move footer up on iPhone X - iOS 11.0 */
        margin-bottom: env(safe-area-inset-bottom) !important; /* move footer up on iPhone X - iOS 11.2 */
        /*margin: 14px 0 !important;
        patting-bottom: constant(safe-area-inset-bottom) !important;
        padding-bottom: env(safe-area-inset-bottom) !important;
        padding: 7px 0 !important;*/
    }

    .border {
        border: 4px solid #333 !important;
    }

    .mb-menu {
        margin-bottom: 100px;
    }

    .size65 .v-image__image--cover {
        background-size: 65% !important;
    }

    .rem4 {
        font-size: 4rem !important;
    }
</style>